import React from 'react';
import {withRouter} from 'react-router-dom';
import {inject} from 'mobx-react';

@withRouter
@inject('alertStore')
export default class InvalidUserAlert extends React.Component {

  componentWillMount(){
    this.routerListener = this.props.history.listen(() => {
          this.props.alertStore.success('Update your profile please')
        });
  }

  componentWillUnmount(){
    this.routerListener();
  }

  render(){
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/blocks/InvalidUserAlert.js